import { Link } from 'react-router-dom'
import { Container } from './style'

import { Title } from '../title'
import { Button } from '../button'

const CadastrarPlataforma = () => {
    return (
        <Container>
            <Title>Quer se cadastrar na nossa plataforma?</Title>
            <p>
                Faça parte da primeira plataforma focado
                em ecossistema empreendedor, invocador e
                de Startups de Sergipe
            </p>
            <Link to="/cadastrar-usuario">
                <Button>Faça seu cadastro!</Button>
            </Link>
        </Container>
    )
}

export default CadastrarPlataforma
